import { useTranslation } from 'react-i18next';
import DropdownButton from '../dropdown-button/dropdown-button';
import QuickApprovalModal from '../quick-approval-modal/quick-approval-modal';
import { useState } from 'react';
import { useDispatch } from 'react-redux';
import { useSnackbar } from 'notistack';
import { apiHelper } from '../../hooks/apiHelper';
import ConfirmPopUp from '../confirm-modal/confirm-modal';

export const ApprovalWrapper = ({
	data,
	addApprover,
	fetchApi,
	showAcceptOrReject,
	moduleIdKey,
	moduleId,
	successMessage,
	showSubmitBtn,
	updateApi,
	approvalDetails,
	title
}: any) => {
	//Translations
	const { t } = useTranslation();

	//Redux
	const dispatch = useDispatch();

	//Snackbar
	const { enqueueSnackbar } = useSnackbar();

	//Local State
	const [isUpdatingApproval, setIsUpdatingApproval] = useState(false);
	const [openQuickApprovalModal, setOpenQuickApprovalModal] = useState(false);
	const [approvalToAcceptOrReject, setApprovalToAcceptOrReject] =
		useState<string>('');

	//Handlers

	const FetchApprovalDetails = () => {
		if (successMessage) {
			enqueueSnackbar(t(successMessage));
		}
		fetchApi();
	};

	const handleSubmitForApproval = async (
		type: 'submit_for_approval' | 'quick_approval',
		approvers?: number[]
	) => {
		if (data) {
			setIsUpdatingApproval(true);
			const payload = {
				[moduleIdKey]: moduleId,
				type,
				...(approvers && approvers?.length && { approver_id: approvers })
			};

			const response = await dispatch(addApprover(payload));

			setIsUpdatingApproval(false);
			apiHelper(response, () => FetchApprovalDetails(), enqueueSnackbar);
		}
	};

	const handleApprovalAcceptOrReject = async () => {
		if (approvalDetails?.id && approvalToAcceptOrReject) {
			const payload = {
				id: approvalDetails?.id,
				[moduleIdKey]: moduleId,
				status: approvalToAcceptOrReject
			};
			setIsUpdatingApproval(true);
			const response = await dispatch(updateApi(payload));
			setIsUpdatingApproval(false);
			const rStatus = approvalToAcceptOrReject;
			setApprovalToAcceptOrReject('');
			apiHelper(response, () => fetchApi(), enqueueSnackbar);
			if (response.meta.requestStatus === 'fulfilled') {
				const msg = `${title} ${rStatus === 'Approved' ? t('common.accepted') : t('common.rejected')}`;
				enqueueSnackbar(msg);
			}
		}
	};

	return (
		<>
			{(showSubmitBtn || data?.status === 'Rejected') && (
				<DropdownButton
					isMenuThirdItemDisabled={true}
					onClick={() => handleSubmitForApproval('submit_for_approval')}
					options={[
						{
							label: t('common.submitForApproval'),
							callback: () => handleSubmitForApproval('submit_for_approval')
						},
						{
							label: t('common.quickApproval'),
							callback: () => setOpenQuickApprovalModal(true)
						}
					]}
					loading={isUpdatingApproval}>
					{data?.status === 'Rejected'
						? t('common.reSubmit')
						: t('common.submit')}
				</DropdownButton>
			)}
			<QuickApprovalModal
				isOpen={openQuickApprovalModal}
				setIsOpen={() => setOpenQuickApprovalModal(false)}
				onConfirm={(approverIds) =>
					handleSubmitForApproval('quick_approval', approverIds)
				}
				isProcessing={isUpdatingApproval}
			/>
			<ConfirmPopUp
				open={Boolean(approvalToAcceptOrReject)}
				onClose={() => setApprovalToAcceptOrReject('')}
				onConfirm={handleApprovalAcceptOrReject}
				title={`${approvalToAcceptOrReject} request`}
				description={`Are you sure you want to ${approvalToAcceptOrReject} ${title} : ${data?.id} ?`}
				buttonTexts={{
					confirm: t('common.submit'),
					cancel: t('common.cancel')
				}}
				buttonColors={{
					confirm: approvalToAcceptOrReject === 'Rejected' ? 'error' : 'info'
				}}
				modalType='info'
				loading={isUpdatingApproval}
			/>
			{showAcceptOrReject && (
				<DropdownButton
					isMenuThirdItemDisabled={true}
					onClick={() => setApprovalToAcceptOrReject('Approved')}
					options={[
						{
							label: t('common.accept'),
							callback: () => setApprovalToAcceptOrReject('Approved')
						},
						{
							label: t('common.reject'),
							callback: () => setApprovalToAcceptOrReject('Rejected'),
							color: 'theme.error.500'
						}
					]}
					loading={isUpdatingApproval}>
					{t('common.accept')}
				</DropdownButton>
			)}
		</>
	);
};

export default ApprovalWrapper;
